import BusinessAnalysisComponent from './component';

class BusinessAnalysisRoute extends BusinessAnalysisComponent {

}

export default BusinessAnalysisRoute;
